import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Composant standalone pour l'iframe
import GoldYearWidgetPage from './GoldYearWidgetPage';

import ProtectedRoute from './ProtectedRoute';
import UserLayout from './UserLayout';
import Dashboard from './Dashboard';
import Products from './Products';
import Currencies from './Currencies';
import News from './News';
import NewsDetail from './NewsDetail';
import Agences from './Agences';
import Marges from './Marges';
import Analytics from './Analytics';
import MetalsLiveChart from './MetalsLiveChart';
import AdminUserManagement from './AdminUserManagement';
import UserCreation from './UserCreation';
import TokenManager from './TokenManager';
import ChartBuilder from './ChartBuilder';
import ChartList from './ChartList';
import EmbedChart from './EmbedChart';
import CsvExport from './CsvExport';
import Login from './Login';
import Signup from './Signup';

function App() {
  return (
    <Router>
      <Routes>
        {/* ===== Page publique embarquable ===== */}
        <Route path="/embed/gold-year" element={<GoldYearWidgetPage />} />

        {/* ===== Authentification ===== */}
        <Route path="/login"  element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* ===== Routes protégées ===== */}
        <Route element={<ProtectedRoute><UserLayout /></ProtectedRoute>}>
          <Route path="/dashboard"        element={<Dashboard />} />
          <Route path="/products"         element={<Products />} />
          <Route path="/currencies"       element={<Currencies />} />
          <Route path="/metals/live"      element={<MetalsLiveChart />} />
          <Route path="/news"             element={<News />} />
          <Route path="/news/:id"         element={<NewsDetail />} />
          <Route path="/agences"          element={<Agences />} />
          <Route path="/marges"           element={<Marges />} />
          <Route path="/analytics"        element={<Analytics />} />
          <Route path="/user-management"  element={<AdminUserManagement />} />
          <Route path="/create-user"      element={<UserCreation />} />
          <Route path="/create-token"     element={<TokenManager />} />
          <Route path="/charts"           element={<ChartBuilder />} />
          <Route path="/charts/list"      element={<ChartList />} />
          <Route path="/charts/embed/:id" element={<EmbedChart />} />
          <Route path="/export-csv"       element={<CsvExport />} />
        </Route>

        {/* ===== Fallback ===== */}
        <Route path="*" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;